export const visit = (vm, at) => {
vm(require("foundations-components/lang/fr.lyaml"));
at({ "fr": { "placeholder": "variable" } });
};